// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    // Card
    description:
      "Define asset classes for products in this collection (e.g., Equities, Fixed Income, Cash). Products can be allocated across multiple asset classes.",
    // Table headers
    name: "Name",
    linkedInstrument: "Linked Instrument",
    products: "Products",
    actions: "Actions",
    // Messages
    noAssetClasses: 'No asset classes configured. Click "Add Asset Class" to create one.',
    notLinked: "Not linked",
    // Alerts
    error: "Error",
    failedToDelete: "Failed to delete asset class",
    // Actions
    addAssetClass: "Add Asset Class",
    selections: "Selections",
    // Confirm dialog
    deleteTitle: "Delete Asset Class",
    deleteDescription:
      "Are you sure you want to delete this asset class? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
  },
  nb_NO: {
    edit: "Rediger",
    // Card
    description:
      "Definer aktivaklasser for produkter i denne samlingen (f.eks. aksjer, obligasjoner, kontanter). Produkter kan allokeres på tvers av flere aktivaklasser.",
    // Table headers
    name: "Navn",
    linkedInstrument: "Koblet instrument",
    products: "Produkter",
    actions: "Handlinger",
    // Messages
    noAssetClasses:
      'Ingen aktivaklasser konfigurert. Klikk "Legg til aktivaklasse" for å opprette en.',
    notLinked: "Ikke koblet",
    // Alerts
    error: "Feil",
    failedToDelete: "Kunne ikke slette aktivaklasse",
    // Actions
    addAssetClass: "Legg til aktivaklasse",
    selections: "Utvalg",
    // Confirm dialog
    deleteTitle: "Slett aktivaklasse",
    deleteDescription:
      "Er du sikker på at du vil slette denne aktivaklassen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
  },
} as const;
